module.exports = __webpack_public_path__ + "static/media/galerija_2023 (5).dff95fd9.jpg";